<template>
    <div class="w-full flex flex-wrap text-sm bg-gray-200 rounded-2xl p-2 font-medium">
        <div @click="select(option)" v-for="(option, index) in options" class="flex-1 text-center px-4 py-3 cursor-pointer rounded-xl" :class="{
            'bg-regal-blue-700 text-white' : option.active,
            'hover:text-regal-blue-700 hover:bg-gray-200 text-gray-700' : ! option.active,
        }">{{ option.title }}</div>
    </div>
</template>

<script>
    import { computed, ref } from 'vue'

    export default {
        props: ['options'],
        methods: {
            select(option) {
                this.options.forEach((el) => {
                    el.active = false;
                    if (el.title == option.title) {
                        el.active = true;
                    }
                });
            },
        },
    }
</script>
